import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../footer.js';
import InvoiceModal from './posting/invoiceModal.js';
import Payment from './posting/payment.js';
import CreditMemo from './posting/creditMemo.js';
import Header from '../../header/header.js';
import Navvbar from '../../header/Navvbar.js';

const FinanceOwerview = () => {
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showCreditMemoModal, setShowCreditMemoModal] = useState(false);
  const [showReceivePaymentModal, setShowReceivePaymentModal] = useState(false);

  
  const handleCloseInvoiceModal = () => setShowInvoiceModal(false);

  
  const handleCloseCreditMemoModal = () => setShowCreditMemoModal(false);

  
  const handleCloseReceivePaymentModal = () => setShowReceivePaymentModal(false);


  const linkStyle = {
    textDecoration: 'none',
    color: '#004aad',
  };

  const headingStyle = {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    marginLeft:"5px",
    marginBottom: "0",  // Remove margin from the bottom of the heading
  };

  const paragraphStyle = {
    color: '#6c757d',
    marginLeft:"20px",
    marginTop: "0", // Remove top margin of paragraph
    marginBottom: "0",  // Remove bottom margin of paragraph
  };


  return (
    <>
      <Header />
      <Navvbar/>
      <br />
      <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
              <div className="col-md-10">
                 <div className="main-content">
                   <h2>Finances</h2>
                 
                   <div className="setting">
                     <Link to="/posting" style={linkStyle}>
                       <h6 style={headingStyle}>Postings</h6>
                     </Link>
                     <p style={paragraphStyle}>View ledger of all account postings</p>
                   </div>
                   <div className="setting">
                     <Link to="/statement" style={linkStyle}>
                       <h6 style={headingStyle}>Manage Statements</h6>
                     </Link>
                     <p style={paragraphStyle}>View and manage statements.</p>
                   </div>
                 </div>
              </div>
           </div>

      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
        <Footer />
      </div>
      <InvoiceModal show={showInvoiceModal} handleClose={handleCloseInvoiceModal} />
      <CreditMemo show={showCreditMemoModal} handleClose={handleCloseCreditMemoModal} />
      <Payment show={showReceivePaymentModal} handleClose={handleCloseReceivePaymentModal} />
    </>
  );
};

export default FinanceOwerview;
